//@flow
export const colors = {
  white: '#fff',
  yellow: '#FBC02D',
  orange500: '#FF9800',
  orange650: '#E65100',
  orange600: '#F57C00',
  orange200: '#FFB74D',
  red500: '#F44336',
  red650: '#B71C1C',
  red600: '#D32F2F',
  red200: '#E57373',
  red50: '#FFCDD2',

  green500: '#60D658',
  blue500: '#1976D2',
  purple: '#4A148C',

  theme600: '#56C04F',
  theme500: '#60D658',

  gray800: '#333333',
  gray600: '#5c6674',
  gray400: '#8492A6',
  gray350: '#a9b3c1',
  gray300: '#ced3db',
  gray200: '#e6e9ed',
  gray100: '#f5f6f8',
  gray50: '#f7f7f7',
  gray25: '#f9f9f9',
  primary1: '#60D658',
  primary4: '#EFFBEE',
  text: '#112232'
}
